(function (wp) {
  if (!wp || !wp.blocks || !wp.element || !wp.i18n) {
    return;
  }

  const { registerBlockType } = wp.blocks;
  const { __ } = wp.i18n;
  const { createElement: el, Fragment } = wp.element;
  const blockEditor = wp.blockEditor || wp.editor || {};
  const components = wp.components || {};
  const InspectorControls = blockEditor.InspectorControls;
  const useBlockProps = blockEditor.useBlockProps;
  const PanelBody = components.PanelBody;
  const ToggleControl = components.ToggleControl;
  const TextControl = components.TextControl;
  const SelectControl = components.SelectControl;
  const ServerSideRender = wp.serverSideRender && (wp.serverSideRender.default || wp.serverSideRender);
  const settingsUrl = window.dcawGutenbergConfig && window.dcawGutenbergConfig.settingsUrl;

  const getBlockProps = () => {
    return typeof useBlockProps === 'function'
      ? useBlockProps({ className: 'dcaw-gutenberg-preview' })
      : { className: 'dcaw-gutenberg-preview' };
  };

  const renderSettingsHint = (message) => {
    if (!settingsUrl) {
      return el('p', { className: 'components-base-control__help' }, message);
    }

    return el('p', { className: 'components-base-control__help' },
      message + ' ',
      el('a', { href: settingsUrl, target: '_blank', rel: 'noopener noreferrer' }, __('Open DITS Compare settings', 'dits-compare'))
    );
  };

  registerBlockType('dits/compare-table', {
    apiVersion: 2,
    title: __('DITS Compare Table', 'dits-compare'),
    description: __('Displays the WooCommerce compare table managed by DITS Compare.', 'dits-compare'),
    icon: 'table-col-after',
    category: 'widgets',
    attributes: {
      showCategories: {
        type: 'boolean',
        default: true
      },
      theme: {
        type: 'string',
        default: 'default'
      },
      variant: {
        type: 'string',
        default: 'default'
      }
    },
    edit: function (props) {
      const blockProps = getBlockProps();

      return el(Fragment, {},
        InspectorControls && el(InspectorControls, {},
          el(PanelBody, { title: __('Settings', 'dits-compare'), initialOpen: true },
            el(ToggleControl, {
              label: __('Show category filter', 'dits-compare'),
              checked: !!props.attributes.showCategories,
              onChange: function (value) {
                props.setAttributes({ showCategories: value });
              }
            }),
            renderSettingsHint(__('Compared fields, popups, and other global compare behavior are configured in the plugin settings.', 'dits-compare'))
          )
        ),
        InspectorControls && el(InspectorControls, { group: 'styles' },
          el(PanelBody, { title: __('Style', 'dits-compare'), initialOpen: true },
            el(SelectControl, {
              label: __('Color theme', 'dits-compare'),
              value: props.attributes.theme || 'default',
              options: [
                { label: __('Use plugin default', 'dits-compare'), value: 'default' },
                { label: __('Light', 'dits-compare'), value: 'light' },
                { label: __('Dark', 'dits-compare'), value: 'dark' },
                { label: __('Aurora', 'dits-compare'), value: 'aurora' }
              ],
              onChange: function (value) {
                props.setAttributes({ theme: value });
              }
            }),
            el(SelectControl, {
              label: __('Visual style', 'dits-compare'),
              value: props.attributes.variant || 'default',
              options: [
                { label: __('Use plugin default', 'dits-compare'), value: 'default' },
                { label: __('Modern', 'dits-compare'), value: 'modern' },
                { label: __('Classic', 'dits-compare'), value: 'classic' }
              ],
              onChange: function (value) {
                props.setAttributes({ variant: value });
              }
            }),
            renderSettingsHint(__('These controls override the default table style. Global defaults are still configured in the plugin settings.', 'dits-compare'))
          )
        ),
        el('div', blockProps,
          ServerSideRender
            ? el(ServerSideRender, {
              block: 'dits/compare-table',
              attributes: props.attributes
            })
            : el('p', {}, __('Block preview is unavailable.', 'dits-compare'))
        )
      );
    },
    save: function () {
      return null;
    }
  });

  registerBlockType('dits/compare-button', {
    apiVersion: 2,
    title: __('DITS Compare Button', 'dits-compare'),
    description: __('Displays a DITS compare button for the current product or a specific product ID.', 'dits-compare'),
    icon: 'button',
    category: 'widgets',
    attributes: {
      productId: {
        type: 'string',
        default: ''
      }
    },
    edit: function (props) {
      const blockProps = getBlockProps();

      return el(Fragment, {},
        InspectorControls && el(InspectorControls, {},
          el(PanelBody, { title: __('Settings', 'dits-compare'), initialOpen: true },
            el(TextControl, {
              label: __('Product ID', 'dits-compare'),
              help: __('Leave empty on a product template to use the current product automatically.', 'dits-compare'),
              value: props.attributes.productId || '',
              onChange: function (value) {
                props.setAttributes({ productId: value });
              }
            }),
            renderSettingsHint(__('Button text, display mode, and popup behavior are configured in the plugin settings.', 'dits-compare'))
          )
        ),
        el('div', blockProps,
          ServerSideRender
            ? el(ServerSideRender, {
              block: 'dits/compare-button',
              attributes: props.attributes
            })
            : el('p', {}, __('Block preview is unavailable.', 'dits-compare'))
        )
      );
    },
    save: function () {
      return null;
    }
  });
}(window.wp));
